export default "__VITE_ASSET__DouHSu59__"